import { ShieldCheck } from "lucide-react"

export function NitaBadge({ className = "", compact = false }) {
  return (
    <a
      href="https://www.nita.go.ug/"
      target="_blank"
      rel="noopener noreferrer"
      data-testid="nita-badge"
      title="Certified by the National Information Technology Authority – Uganda (CCL2), valid Mar 2026 – Mar 2027"
      className={`inline-flex items-center gap-2.5 rounded-xl border border-[#2A7D4A]/40 bg-[#1B5E35]/15 px-4 py-2.5 transition-colors hover:border-[#2A7D4A] ${className}`}
    >
      <ShieldCheck className="h-5 w-5 shrink-0 text-[#2A7D4A]" />
      <span className="leading-tight">
        <span className="block text-xs font-bold text-[#F4F6F0]">NITA-U Certified IT Provider (CCL2)</span>
        {!compact && <span className="block text-[10px] text-[#9fb0a3]">National Information Technology Authority – Uganda · valid to Mar 2027</span>}
      </span>
    </a>
  )
}
